const settingsResolver = (data) => {
  return {
    borrowerMinimumAge: data.borrower_minimum_age,
    borrowerMaximumAge: data.borrower_maximum_age,
    ageNextBirthdayGracePeriod: data.age_next_birthday_grace_period,
  };
};

export default settingsResolver;
